import dateFNS from './dateFns';

export const toISOString: any = (value: Date[] | Date) => {
  if (Array.isArray(value)) {
    return value.map(toISOString);
  }
  return dateFNS.isDate(value) && dateFNS.isValid(value)
    ? value.toISOString()
    : value;
};

const getOffsetByTimeZone = (dateValue: Date, timeZone: string) => {
  if (timeZone === 'utc') {
    return dateValue.getTimezoneOffset();
  } else {
    return 0;
  }
};

export const toDate: any = (value: string[] | string | Date) => {
  if (Array.isArray(value)) {
    return value.map(row => toDate(row));
  }
  if (value instanceof Date) {
    return value;
  }
  if (value === null) {
    return undefined;
  }

  const result = new Date(value);
  if (!dateFNS.isValid(result)) {
    return value;
  }

  return result;
};

export const fromUTCToTimeZone: any = (
  value: string[] | string,
  timeZone = 'utc'
) => {
  if (Array.isArray(value)) {
    return value.map(row => fromUTCToTimeZone(row, timeZone));
  }
  if (!value) {
    return value;
  }
  const normalizedValue = toDate(value);

  const timeZoneOffset = getOffsetByTimeZone(normalizedValue, timeZone);
  const fixedTimeZoneDate = dateFNS.addMinutes(normalizedValue, timeZoneOffset);
  const realTimeZoneOffset = getOffsetByTimeZone(fixedTimeZoneDate, timeZone);
  return dateFNS.addMinutes(normalizedValue, realTimeZoneOffset);
};

export const fromTimeZoneToUTC: any = (
  value: string[] | string,
  timeZone = 'utc'
) => {
  if (Array.isArray(value)) {
    return value.map(row => fromTimeZoneToUTC(row, timeZone));
  }
  if (!value) {
    return value;
  }
  const normalizedValue = toDate(value);
  const timeZoneOffset = getOffsetByTimeZone(normalizedValue, timeZone);
  return dateFNS.subMinutes(normalizedValue, timeZoneOffset);
};
